export default function SuccessModal({ onClose }) {
  return (
    <div style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,.55)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999
    }}>
      <div style={{
        width: 500,
        background: "#fff",
        padding: 40,
        borderRadius: 12,
        textAlign: "center"
      }}>
        <h2>
          Thank You For Your Purchase
        </h2>

        <p>
          Your order has been received and your payment
          has been successfully processed.
        </p>

        <p>
          A confirmation email will be sent shortly with
          details of your order and collection/delivery
          arrangements.
        </p>

        <button
          onClick={onClose}
          style={{
            border: "1px solid black",
            marginTop: 20,
            padding: "12px 24px",
            cursor: "pointer"
          }}
        >
          Continue
        </button>
      </div>
    </div>
  );
}